/* eslint-disable no-useless-constructor */
// @flow

import "./form.css";

import "core-js/stable"; // needed for promises and async/await
import "regenerator-runtime/runtime"; // needed for promises and async/await
import { Core } from "../../../VanillaCore";

export default class FormComponent extends Core.Component {
  form;
  submitBtn;
  submitText;
  cancelBtn;
  cancelText;

  constructor(sandbox: Core.Sandbox) {
    super(sandbox);
  }

  init() {
    this.form = document.querySelector('form');
    this.submitBtn = document.querySelector('[type=submit]');
    this.submitText = document.querySelector('.submit-text');
    this.cancelBtn = document.querySelector('[type=button][name=CANCEL]');
    this.cancelText = document.querySelector('.cancel-text');

    if (this.cancelBtn) {
      this.cancelBtn.addEventListener('click', (e) => {
        this.cancel(e);
      });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  destroy() {}

  submit(evt: Event) {
    this.disableButtons();
    this.submitText.style.display = 'none';
    this.submitBtn.classList.add('animating');
    this.submitWithExtraParam();
  }

  // eslint-disable-next-line no-unused-vars
  cancel(evt: Event) {
    this.disableButtons();
    this.cancelText.style.display = 'none';
    this.cancelBtn.classList.add('animating');
    this.submitWithExtraParam("CANCEL");
  }

  disableButtons() {
    this.submitBtn.disabled = true;
    this.cancelBtn.disabled = true;
  }

  submitWithExtraParam(param: ?string) {
    const formElement = this.form;
    if (!(formElement instanceof HTMLFormElement)) {
      throw new Error("Oops. Trying to submit something other than a form.");
    } else if (formElement instanceof HTMLFormElement) {
      const theForm: HTMLFormElement = formElement;

      if (param) {
        // add the CANCEL parameter
        if (theForm.action.indexOf("?") === -1) theForm.action += `?${param}`;
        else theForm.action += `&${param}`;
      }

      // if the form has an onsubmit handler call it
      if (theForm.onsubmit)
        theForm.onsubmit();

      // submit the form (even if the onsubmit handler said not to (because we're canceling!))
      theForm.submit();
    }
  }
}
